import { DeleteOutlined } from '@ant-design/icons'
// import { message } from 'antd'
import { useState } from 'react'
import { ButtonCommon } from 'src/common'
import ActionWordTypeCommon from 'src/common/ActionWordTypeCommon/ActionWordTypeCommon'
import { onDeleteDictWordTypes } from 'src/redux/dict/dict.action'
import { showMessageError } from 'src/utils/function.utils'
import PopconfirmCommon from '../../../common/PopconfirmCommon/PopconfirmCommon'
import { useAppDispatch } from '../../../hooks'

export const DictWordTypeAction = ({ onEdit, data }) => {
	const dispatch = useAppDispatch()
	const [visible, setVisible] = useState(false)
	const [confirmLoading, setConfirmLoading] = useState(false)

	const onConfirmDelete = () => {
		setConfirmLoading(true)
		dispatch(
			onDeleteDictWordTypes(
				{
					// id: wordTypeId,
					id: data?.id,
				},
				onDeleteCallback
			)
		)
	}

	const onCancel = () => {
		setVisible(false)
	}

	const onDeleteCallback = isSuccess => {
		setConfirmLoading(false)
		if (isSuccess) {
			setVisible(false)
		} else {
			// message.error(rs)
			showMessageError("can't not delete your word type")
		}
	}

	const showPopconfirm = () => {
		setVisible(true)
	}

	return (
		<div className="u-row-center">
			<PopconfirmCommon
				visible={visible}
				onConfirm={onConfirmDelete}
				title="Are you sure to delete this word and related data permanently?"
				placement="left"
				okButtonProps={{ loading: confirmLoading }}
				onCancel={onCancel}
			>
				<ButtonCommon onClick={showPopconfirm}>
					<DeleteOutlined />
				</ButtonCommon>
			</PopconfirmCommon>
			<ActionWordTypeCommon onEditClick={onEdit} record={data} />
		</div>
	)
}
